import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=a9a25a08&scoped=true&"
import script from "./SummarySection.vue?vue&type=script&lang=js&"
export * from "./SummarySection.vue?vue&type=script&lang=js&"
import style0 from "./SummarySection.vue?vue&type=style&index=0&id=a9a25a08&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a25a08",
  null
  
)

export default component.exports